module.exports = __webpack_public_path__ + "static/media/mobile_instagram_video.40e02002.png";